import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { modeExecution, SITE_WEB  } from './Global.js';
import './ListTreasure.css';
import folderIcon from '../images/coins_13470111.png';
import treasureIcon from '../images/green_folder_1.png';
import { ChevronDown } from 'react-bootstrap-icons';

const ListTreasure = React.forwardRef(({ onTreasureSelect, onDatasetSelect }, ref) => {
    const [treasures, setTreasures] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [expandedTreasure, setExpandedTreasure] = useState(null);

    React.useImperativeHandle(ref, () => ({
        resetSelection: () => {
            setSelectedItem(null);
            setExpandedTreasure(null);
        }
    }));
    
  useEffect(() => {
        const fetchTreasures = async () => {
            const token = sessionStorage.getItem('token');
            try {
                let response;
                let route_tmp = SITE_WEB + '/treasures'
                console.log("[ListTreasure] [fetchTreasures] route_tmp = ", route_tmp)

                    response = await axios.get(route_tmp, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });                

                setTreasures(response.data);
            } catch (error) {
                console.error('Error fetching treasures:', error);
                setTreasures([]);
            }
        };

        fetchTreasures();
  }, []);

  const handleTreasureClick = (treasure) => {
      let _dump = true;
      
      // Si on clique sur le même trésor, on le déselectionne
      if (selectedItem?.name === treasure.name && expandedTreasure === treasure.name) {
          if(_dump) console.log("Désélection du trésor:", treasure.name);
          setSelectedItem(null);
          setExpandedTreasure(null);
          onTreasureSelect({ type: 'deselect' });
          return;
      }

      if (expandedTreasure === treasure.name) {
        // Simple repli du menu
        if(_dump) console.log("Repli du menu du trésor:", treasure.name);
        setExpandedTreasure(null);
        onTreasureSelect({ type: 'collapse' });
        return;
    }
  
      // Sinon, sélection normale
      setExpandedTreasure(treasure.name);
      setSelectedItem({ name: treasure.name, type: 'treasure' });
      onTreasureSelect({ item: treasure, type: 'treasure' });
  };
  



  const handleDatasetClick = (dataset, treasureName) => {
    let _dump = true;
    if(_dump) console.log("[ListTreasure] (handleDatasetClick) *** Selection dataset:", dataset);

    // Si on clique sur le dataset déjà sélectionné
    if (selectedItem?.name === dataset) {
        if(_dump) console.log("[ListTreasure] Même dataset, on ignore");
        return;
    }      
    setSelectedItem({ name: dataset, type: 'dataset' });
    onTreasureSelect({ 
        item: {
            name: dataset,
            treasureParent: treasureName,
            type: 'dataset'
        },
        type: 'dataset'
    });
  }; // fin handleDatasetClick




    useEffect(() => {
        if (!selectedItem) {
            setExpandedTreasure(null);
        }
    }, [selectedItem]);

  return (
      <div className="treasure-section">
          <h3 className="section-title">Treasures</h3>
          <div className="treasure-list">
              {treasures.map((treasure) => (
                  <div key={treasure.name} className="treasure-group">
                      <div 
                          className={`treasure-item ${selectedItem?.name === treasure.name ? 'selected' : ''}`}
                          onClick={() => handleTreasureClick(treasure)}
                      >
                          <img src={treasureIcon} alt="treasure" className="treasure-icon" />
                          <span className="treasure-name">{treasure.name}</span>
                          <ChevronDown 
                              className={`expand-arrow ${expandedTreasure === treasure.name ? 'expanded' : ''}`}
                          />
                      </div>
                      <div className={`datasets-container ${expandedTreasure === treasure.name ? 'expanded' : ''}`}>
                          {treasure.config?.allowedDatasets?.map((dataset) => (
                              <div
                                  key={dataset}
                                  className={`dataset-item ${selectedItem?.name === dataset ? 'selected' : ''}`}
                                  onClick={() => handleDatasetClick(dataset, treasure.name)}
                              >
                                  <img src={folderIcon} alt="dataset" className="dataset-icon" />
                                  <span className="dataset-name">{dataset}</span>
                              </div>
                          ))}
                      </div>
                  </div>
              ))}
          </div>
      </div>
  );
});

export default ListTreasure;